{
  "cycle.entite.depot_actualisations": "Actualisations du dépôt",
  "v6.depot.choisir": "— Choisir —",
  "v6.depot.code.ACCESS_DENIED": "Il faut être membre actif du projet pour ce geste.",
  "v6.depot.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire pour lire le dépôt de ce projet.",
  "v6.depot.code.IDEMPOTENCY_CONFLICT": "Une actualisation du dépôt est déjà en cours pour ce projet.",
  "v6.depot.code.SCM_NOT_CONFIGURED": "Le dépôt de ce projet n’est pas raccordé : un administrateur du projet doit enregistrer sa connexion GitLab.",
  "v6.depot.code.SCM_NOT_FOUND": "Cette référence ou ce pipeline est inconnu du dépôt.",
  "v6.depot.code.SCM_UNAVAILABLE": "L’outil de dépôt est injoignable pour le moment.",
  "v6.depot.code.VALIDATION_ERROR": "Référence ou identifiant illisible.",
  "v6.depot.environnement.libelle": "Environnement concerné",
  "v6.depot.environnement.vide": "Ce projet n’a déclaré aucun environnement.",
  "v6.depot.etapes.titre": "Étapes du pipeline",
  "v6.depot.etapes.trace": "Voir la trace",
  "v6.depot.etapes.trace_de": "Voir la trace de l’étape {{etape}}",
  "v6.depot.etapes.vide": "Ce pipeline n’a aucune étape.",
  "v6.depot.etat.chargement": "Chargement de {{quoi}}…",
  "v6.depot.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v6.depot.etat.introuvable": "{{quoi}} : introuvable.",
  "v6.depot.etat.reessayer": "Réessayer",
  "v6.depot.etat.refus": "Vous ne pouvez pas lire {{quoi}}.",
  "v6.depot.pipeline.absent": "Aucun pipeline n’est désigné : ouvrez cette fiche depuis le cockpit de livraison.",
  "v6.depot.pipeline.identifiant": "Identifiant",
  "v6.depot.pipeline.libelle": "le pipeline",
  "v6.depot.pipeline.panneau": "Pipeline",
  "v6.depot.pipeline.reference": "Référence",
  "v6.depot.pipeline.resume": "Pipeline #{{id}} · {{statut}} · {{commit}}",
  "v6.depot.pipeline.titre": "Pipeline de livraison",
  "v6.depot.reference.absente": "Aucune référence n’est désignée : ouvrez cette fiche depuis le cockpit de livraison.",
  "v6.depot.reference.aucun_pipeline": "Aucun pipeline sur ce commit.",
  "v6.depot.reference.auteur": "Auteur",
  "v6.depot.reference.auteur_inconnu": "non communiqué par l’outil",
  "v6.depot.reference.commit": "Commit",
  "v6.depot.reference.libelle": "la référence du dépôt",
  "v6.depot.reference.nature": "Nature",
  "v6.depot.reference.nature.branche": "Branche",
  "v6.depot.reference.nom": "Nom",
  "v6.depot.reference.pipelines": "Pipelines du commit",
  "v6.depot.reference.statut": "Statut",
  "v6.depot.reference.statut.active": "active",
  "v6.depot.reference.statut.fusionnee": "fusionnée",
  "v6.depot.reference.statut.protegee": "protégée",
  "v6.depot.reference.titre": "Référence du dépôt",
  "v6.depot.retour_cockpit": "Retour au cockpit de livraison",
  "v6.depot.sans_projet": "Aucun projet n’est choisi : ouvrez cet écran depuis un projet.",
  "v6.depot.statut.annule": "annulé",
  "v6.depot.statut.echoue": "échoué",
  "v6.depot.statut.en_cours": "en cours",
  "v6.depot.statut.termine": "terminé",
  "v6.depot.vague_ulterieure": "« {{ecran}} » mène à un écran qui n’est pas encore réalisé : il arrive avec un paquet ultérieur de la vague V6.",
  "v6.depot.versions.champ": "Version concernée",
  "v6.depot.versions.cible_incomplete": "Choisissez la version et l’environnement pour ouvrir la version.",
  "v6.depot.versions.exacte": "Version rapprochée par son commit exact.",
  "v6.depot.versions.identifiant": "Version {{id}}, commit {{commit}}",
  "v6.depot.versions.ouvrir": "Ouvrir la version",
  "v6.depot.versions.plusieurs": "Plusieurs versions portent ce commit : choisissez celle à ouvrir.",
  "v6.depot.versions.titre": "Versions concernées",
  "v6.depot.versions.vide": "Aucune version du projet ne porte le commit de ce pipeline."
}
